import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useGetSSNRequiredStatesConfiguration() {
  return useCbhFlag(CbhFeatureFlag.CONFIGURE_SSN_REQUIRED_STATES, {
    defaultValue: {
      enabled: false,
      states: [],
    },
  });
}
